<div *ngIf="!!user" class="inline contest-thumbnail no-padding no-margins">
	<a class="inline no-margins no-padding" routerLink="/profile/{{ user?.username }}">
		<img class="block contest-thumbnail-picture no-padding no-margins" *ngIf= "!!user.profilePicture" src="{{ user?.profilePicture }}">
		<img *ngIf= "!!!user.profilePicture" src="/app/assets/images/spotidolBannerPicturePurple.png" class="block contest-thumbnail-picture no-padding no-margins">
		<h2 class="no-margins no-padding ellipsis  contest-thumbnail-width"> {{ user?.username }} </h2>
	</a>
</div>